import React from 'react'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import PropTypes from 'prop-types'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import elementStyles from 'src/components/Elements/elements.module.scss'

const TypeProps = {
  id: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.shape({ label: PropTypes.string, placeholder: PropTypes.string, helper: PropTypes.string }),
  multiline: PropTypes.bool,
  error: PropTypes.string,
  styles: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  props: PropTypes.any,
  maxLength: PropTypes.number,
  icon: PropTypes.shape({ name: PropTypes.string, size: PropTypes.number }),
  fullWidth: PropTypes.bool,
  isLogin: PropTypes.bool
}

const InputComponent = ({
  icon,
  id,
  placeholder,
  onKeyDown,
  maxLength,
  props,
  styles,
  disabled,
  onBlur,
  onChange,
  value,
  type,
  name,
  isLogin
}) => {
  return (
    <div className={elementStyles.inputContainer}>
      {icon?.name && (
        <div className={elementStyles.icon}>
          <IcomoonReact
            iconSet={rebrandIconSet}
            color={variables.c04stonec3c3c3}
            size={icon.size}
            icon={icon.name}
          />
        </div>
      )}
      <input
        className={classNames(
          elementStyles.input,
          isLogin && elementStyles.login,
          { ...styles }
        )}
        style={{ color: disabled && 'gray' }}
        disabled={disabled}
        maxLength={maxLength || 256}
        onBlur={onBlur}
        onChange={onChange}
        value={value || ''}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        id={id}
        name={name}
        type={type}
        {...props}
      />
    </div>
  )
}

const TextAreaComponent = ({ styles, disabled, maxLength, onBlur, onChange, value, placeholder, props, id, name }) => (
  <textarea
    id={id}
    name={name}
    className={classNames(elementStyles.textareaInput, fontStyles.psmalllsin08blackgraphik15pt, id === 'bio' ? elementStyles.bioTextArea : '', {
      ...styles
    })}
    disabled={disabled}
    maxLength={maxLength || 256}
    onBlur={onBlur}
    onChange={onChange}
    value={value || ''}
    placeholder={placeholder}
    {...props}
  />
)

const Input = ({
  id,
  disabled,
  label,
  multiline,
  error,
  styles,
  onBlur,
  onChange,
  onKeyDown,
  value,
  props,
  maxLength,
  icon,
  type,
  name,
  fullWidth = false,
  isLogin = false
}) => {
  return (
    <div style={{ width: fullWidth ? '100%' : 'auto' }} className={elementStyles.formControl}>
      {label.label && !icon && (
        <div className={elementStyles.labelContainer}>
          <span className={fontStyles.psmallboldlsgraphik15pt}>{label.label}</span>
          <span className={elementStyles.labelHelper}>
            {label.helper}
          </span>
        </div>
      )}
      {multiline
        ? <TextAreaComponent
          id={id}
          name={name}
          disabled={disabled}
          maxLength={maxLength || 256}
          onBlur={onBlur}
          onChange={onChange}
          value={value || ''}
          placeholder={label.placeholder}
          styles={styles}
          {...props}
        />
        : (
          <InputComponent
            id={id}
            name={name}
            disabled={disabled}
            maxLength={maxLength || 256}
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={value || ''}
            placeholder={label.placeholder}
            icon={icon}
            type={type}
            styles={styles}
            isLogin={isLogin}
            {...props}
          />
        )}

      {error && icon
        ? <div
          data-testid='inputError'
          className={classNames(
            generalStyles.flexRow,
            generalStyles.alignVertical,
            generalStyles.mt20,
            generalStyles.ml2
          )}
        >
          <IcomoonReact
            iconSet={rebrandIconSet}
            className={elementStyles.errorIcon}
            color={variables.errorGraphicDe0a01}
            size={24}
            icon='Alert'
          />
          <div
            className={classNames(generalStyles.ml25, elementStyles.errorText, generalStyles.ml6, fontStyles.pxsmalllsssgraphik12pt)}
            dangerouslySetInnerHTML={{ __html: error }}
          />
        </div>
        : <div className={elementStyles.errorContainer}>
          <div
            className={classNames(elementStyles.errorText, fontStyles.pxsmalllsssgraphik12pt)}
            dangerouslySetInnerHTML={{ __html: error }}
          />
        </div>
      }
    </div>
  )
}

Input.propTypes = {
  ...TypeProps
}

export default Input
